<app-header></app-header>
<div class="confirm-body h-100">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="card col-6">
            <div class="row mx-auto image p-5">
                <img class="mx-auto" src="assets/images/user-blocked.png"/>
            </div>
            <div class="row mx-auto">
                <h3>{{ "AUTH.CONFIRM.USER_BLOCKED" | translate}}</h3>
            </div>
            <div class="mx-auto">
                <div class="inner-text row m-auto p-5 align-items-center">
                    <h5 class="row mx-auto p-1 align-items-center">
                        <span>{{ 'AUTH.CONFIRM.HEY' | translate }} {{currentUser?.displayName}}! </span> {{ 'AUTH.CONFIRM.USER_BLOCKED_NOTIFICATION1' | translate}}
                    </h5>
                    <h5 class="row mx-auto p-1 align-items-center">
                        {{ 'AUTH.CONFIRM.USER_BLOCKED_NOTIFICATION2' | translate}}
                    </h5>
                </div>
                <div class="row mx-auto p-5">
                    <button type="submit" (click)="backHome()" class="btn btn-primary mx-auto w-30 submit-btn">
                        {{ 'AUTH.CONFIRM.HOME' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
